function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1316",
  "data-name": "Group 1316",
  transform: "translate(-1409 13133)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Component_34_121",
  "data-name": "Component 34 \\u2013 121",
  transform: "translate(1530.509 -13094.285) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1198",
  "data-name": "Group 1198",
  transform: "translate(1326 -13350)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1013",
  "data-name": "Group 1013",
  transform: "translate(59.037 -180)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_750",
  "data-name": "Path 750",
  d: "M2.25-2.25H54.117",
  transform: "translate(22.713 455.209)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_593",
  "data-name": "Path 593",
  d: "M18.456-64.144H28.829",
  transform: "translate(25.822 476.111)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_748",
  "data-name": "Path 748",
  d: "M49.226-56.256a2.745,2.745,0,0,0-.692-1.841,2.255,2.255,0,0,0-1.67-.763H10.1a2.264,2.264,0,0,0-1.676.765,2.755,2.755,0,0,0-.694,1.848V-9.468H49.226Z",
  transform: "translate(22.011 462.468)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_749",
  "data-name": "Path 749",
  d: "M18.456-64.144H39.2",
  transform: "translate(22.165 463.145)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1012",
  "data-name": "Group 1012",
  transform: "translate(35.433 426.23)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1011",
  "data-name": "Group 1011"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1009",
  "data-name": "Group 1009"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_57",
  "data-name": "Line 57",
  x2: 31.12,
  transform: "translate(0 5.187)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_65",
  "data-name": "Line 65",
  x2: 31.12,
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_58",
  "data-name": "Line 58",
  x2: 31.12,
  transform: "translate(0 10.373)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_59",
  "data-name": "Line 59",
  x2: 31.12,
  transform: "translate(0 15.56)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_60",
  "data-name": "Line 60",
  x2: 31.12,
  transform: "translate(0 20.747)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1008",
  "data-name": "Group 1008",
  transform: "translate(15.56) rotate(90)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_61",
  "data-name": "Line 61",
  x2: 20.747,
  transform: "translate(0)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_62",
  "data-name": "Line 62",
  x2: 20.747,
  transform: "translate(0 5.187)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_63",
  "data-name": "Line 63",
  x2: 20.747,
  transform: "translate(0 10.373)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_64",
  "data-name": "Line 64",
  x2: 20.747,
  transform: "translate(0 15.56)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1010",
  "data-name": "Group 1010",
  transform: "translate(66.553 426.23) rotate(90)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_61-2",
  "data-name": "Line 61",
  x2: 20.747,
  transform: "translate(0)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_62-2",
  "data-name": "Line 62",
  x2: 20.747,
  transform: "translate(0 5.187)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_63-2",
  "data-name": "Line 63",
  x2: 20.747,
  transform: "translate(0 10.373)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_64-2",
  "data-name": "Line 64",
  x2: 20.747,
  transform: "translate(0 15.56)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_591",
  "data-name": "Path 591",
  d: "M26.138-18.9H39.1v-6.837H26.138Z",
  transform: "translate(27.431 437.473)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1197",
  "data-name": "Group 1197",
  transform: "translate(82 -122.592)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678",
  "data-name": "Group 678",
  transform: "translate(168 340.592)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_486",
  "data-name": "Path 486",
  d: "M252.959-165.605c0-3.1-2.949-5.613-6.584-5.613H218.608c-3.634,0-6.584,2.515-6.584,5.613V-129.7c0,3.1,2.95,5.613,6.584,5.613h27.767c3.635,0,6.584-2.515,6.584-5.613Z",
  transform: "translate(-212.024 177.654)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489",
  "data-name": "Path 489",
  d: "M220.819-172.117H246.1v-6.333H220.819Z",
  transform: "translate(-212.992 178.45)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  "data-name": "Path 492",
  d: "M220.819-115.221H246.1v-1.585H220.819Z",
  transform: "translate(-212.992 171.284)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  "data-name": "Path 495",
  d: "M212.168-162.192h40.68",
  transform: "translate(-212.04 176.563)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498",
  "data-name": "Path 498",
  d: "M212.168-127.273h40.68",
  transform: "translate(-212.04 172.437)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_517",
  "data-name": "Path 517",
  d: "M232.159-149.994s4.449,6.844,4.449,9.3a4.451,4.451,0,0,1-4.449,4.449,4.452,4.452,0,0,1-4.45-4.449C227.709-143.15,232.159-149.994,232.159-149.994Z",
  transform: "translate(-43.691 514.129)",
  fill: "#48b05e",
  fillRule: "evenodd"
}))));

var SvgNewExtraction = function SvgNewExtraction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208.935,
    height: 58.063,
    viewBox: "0 0 208.935 58.063",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewExtraction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-extraction.4e11b7b2.svg";
export { ForwardRef as ReactComponent };